import { styled, Toolbar } from "@mui/material";

const ToolbarStyled = styled(Toolbar)(({ }) => ({
    display: 'flex',
    justifyContent: 'space-between',
}))

export default ToolbarStyled